import React, { useState, useEffect } from "react";
import { compose, withProps } from "recompose";
import {
	Row,
	Table,
	Col,
	Card,
	CardBody,
	TabContent,
	TabPane,
	CardTitle,
	NavLink,
	Label,
	Input,
	Alert,
	Button,
	FormGroup,
	Container,
	CustomInput,
	CardImg,
} from 'reactstrap';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";

const defaultLocation = { lat: 41.712775, lng: 86.005973 };

const MyMapComponent = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    onClick={ev => {
        props.onMarkerClick(ev.latLng.lat(), ev.latLng.lng());
    }}
    defaultZoom={5}
    defaultCenter={props.markerposition}
  >
    {props.isMarkerShown && (
      <Marker
        title="Marker"
        position={props.markerposition}
        onClick={props.onMarkerClick}
      >
        <InfoWindow options={{ maxWidth: 200 }}>
            <span>"Location of Interest"</span>
        </InfoWindow>
      </Marker>
    )}
  </GoogleMap>
));

class MyFancyComponent extends React.PureComponent {

    constructor(props){
        super(props)
    }

  state = {
    isMarkerShown: true,
    latitude: 0,
    longitude: 0,
    markerposition: defaultLocation,
    observation: "",
    locationInfo: {}
  };

  componentDidMount() {
    this.delayedShowMarker();
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true });
    }, 300);
  };

  handleMarkerClick = (lat, lng) => {
    this.setState({ isMarkerShown: true });
    if(lat !== undefined && lng !== undefined){
        this.setState({ latitude: lat});
        this.setState({ longitude: lng});
        this.setState({markerposition: {lat: this.state.latitude, lng: this.state.longitude}} );
        this.setState({locationInfo: {locationId:0, latitude: this.state.latitude, longitude: this.state.longitude, observation: this.state.observation, userId: -1}})
    }
    this.delayedShowMarker();
  };

  observationStateSectionChange = event => {
    this.setState({
        observation: event.target.value
    });
  };

  render() {
    return (
    <div>
        <div>
            <Row>
                <Col xs={12}>
                    <Card>
                        <CardBody>
                        <h4 className="card-title">Following are data located by you</h4>
                            <p className="card-title-desc">Details. Please move the marker to locate the location of an interest. 
                            After have located the location please write your observations. 
                            The list of added locations will be listed in the table below. 
                            After registering the location you are able to upload supporting images/documents.</p>

                            <FormGroup row>
                                <Label htmlFor="observation-clarification" md="3" className="form-label">
                                    The located geo-coordinates are 
                                </Label>
                                <Col md={9}>
                                    {this.state.markerposition.lat}, {this.state.markerposition.lng}
                                </Col>
                                <Label htmlFor="observation-clarification" md="3" className="form-label">
                                    Personal Observations / Clarification
                                </Label>
                                <Col md={9}>
                                    <Input
                                        type="textarea"
                                        id="observe"
                                        rows="2"
                                        placeholder="Describer Your Observation"
                                        value={this.state.observation}
                                        onChange={event => {
                                            this.observationStateSectionChange(event);
                                        }}
                                    />
                                </Col>
                            </FormGroup>
            
                            <Button to="#" onClick={event => { this.props.submitData(event, this.state) } }>
                                Submit the Current Location and Observation
                            </Button>
                            <br/>
                            <br/>
                            <MyMapComponent
                                isMarkerShown={this.state.isMarkerShown}
                                onMarkerClick={this.handleMarkerClick}
                                latitude={this.state.latitude}
                                longtitude={this.state.longitude}
                                markerposition = {this.state.markerposition}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    </div>
    );
  }
}
export default MyFancyComponent;
